// Local auth state (zustand). JWT real vive en httpOnly cookie — acá sólo
// cacheamos user info for UI (hydratación via /auth/me al boot).
import { create } from 'zustand'
import type { MeResponse } from '../types/bff'

type AuthState = {
  user: MeResponse | null
  initialized: boolean
  setUser: (u: MeResponse | null) => void
  clearUser: () => void
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  initialized: false,
  setUser: (u) => set({ user: u, initialized: true }),
  clearUser: () => set({ user: null, initialized: true }),
}))
